import React from 'react'
import { Formik, Field, ErrorMessage, Form } from "formik"
import { schema, initial, TypeOptions, ShapeOptions } from './Supplies';
import classes from "../../styles/MedicineForm.module.scss";
import { toast } from 'react-toastify';
import { request } from '../../config/helpers/axios-instance';
import { useModalMain } from '../../contexts/modal';
import Cookies from "js-cookie";
import { TENANT_COMPANY_MAP } from '../../utils/constants';
import PropTypes from 'prop-types';
import _ from 'lodash';

function MedicineFormEdit({ medData }) {
    const tenantId = Cookies.get("tenantId");

    const { closeModal } = useModalMain()

    const handleSubmit = async (values, { resetForm }) => {
        try {
            let response = await request({
                method: "PUT", url: `/item/admin/${medData.id}`, data: {
                    manufacture: values.manufacture,
                }
            });
            if (response.data.success) {
                toast.success("Success")
                resetForm({ values: '' })
                closeModal()
            }
            if (!response.data.success) {
                toast.error(response.data.error || "Something went wrong")
            }
        } catch (err) {
            toast.error("Wrong data")
        }
    }

    return (
        <>
            <div>
                <h1 className='font-bold text-3xl text-black' style={{ margin: "15px 10px" }}>Add Medicine Form</h1>
                <Formik initialValues={medData || initial} schema={schema} onSubmit={handleSubmit} enableReinitialize={true}>
                    {
                        () => {
                            return (
                                <Form className='my-3'>
                                    <div className='flex flex-col justify-center items-center my-3'>
                                        <div className='flex flex-col justify-evenly mx-3 my-2 w-[100%]'>
                                            <label htmlFor='name'>Commercial Name</label>
                                            <Field name="name" className={classes.input} required={true} style={{ width: "100%" }} disabled />
                                            <ErrorMessage name="name" />
                                        </div>
                                        <div className='flex flex-col justify-evenly mx-3 w-[100%] my-2'>
                                            <label htmlFor='manufacture'>Manufacturer</label>
                                            <Field name="manufacture" className={classes.input} required={true} style={{ width: "100%" }} />
                                            <ErrorMessage name="manufacture" />
                                        </div>
                                        {
                                            tenantId && tenantId === TENANT_COMPANY_MAP.EAZY && (
                                                <div className='flex flex-col justify-evenly mx-3 w-[100%] my-2'>
                                                    <label htmlFor='manufacture'>Mnemonics Name</label>
                                                    <Field name="mnemonic" className={classes.input} required={true} style={{ width: "100%" }} disabled />
                                                    <ErrorMessage name="mnemonic" />
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='flex justify-center items-center my-3'>
                                        <div className='flex flex-col justify-evenly mx-3'>
                                            <label htmlFor='genericName'>Generic Name</label>
                                            <Field name="genericName" className={classes.input} required={true} disabled />
                                            <ErrorMessage name="genericName" />
                                        </div>
                                        <div className='flex flex-col justify-evenly mx-3'>
                                            <label htmlFor='shape'>Shape</label>
                                            <Field value={_.upperCase(medData.shape)} as="select" name="shape" required={true} className="rounded-xl" disabled>
                                                {ShapeOptions.map((val) => {
                                                    return <option key={val} value={val}>{val}</option>
                                                })}
                                            </Field>
                                            <ErrorMessage name="shape" />
                                        </div>
                                    </div>
                                    <div className='flex justify-center items-center my-3'>
                                        <div className='flex flex-col justify-evenly mx-3'>
                                            <label htmlFor='color'>Color</label>
                                            <Field name="color" className={classes.input} disabled />
                                            <ErrorMessage name="color" />
                                        </div>
                                        <div className='flex flex-col justify-evenly mx-3'>
                                            <label htmlFor='size'>Size</label>
                                            <Field type="number" name="size" className={classes.inputNum} required={true} disabled />
                                            <ErrorMessage name="size" />
                                        </div>
                                    </div>
                                    <div className='flex justify-evenly items-center my-3 w-full'>
                                        <div className='flex flex-col justify-evenly mx-3 w-full'>
                                            <label htmlFor='medicineType'>Type</label>
                                            <Field value={_.upperCase(medData.medicineType)} as="select" name="medicineType" required={true} className="rounded-xl w-full" disabled>
                                                {TypeOptions.map((val) => {
                                                    return <option key={val} value={val}>{val}</option>
                                                })}
                                            </Field>
                                            <ErrorMessage name="medicineType" />
                                        </div>
                                    </div>
                                    <div className={classes.Btndiv}>
                                        <button type='submit'>Submit</button>
                                    </div>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </div>
        </>
    )
}

MedicineFormEdit.propTypes = {
    medData: PropTypes.object.isRequired
};


export default MedicineFormEdit;